import { createReducer } from 'redux-act';

import {
  POIDIRECTORIES_FETCH_DATA_INIT,
  POIDIRECTORIES_FETCH_DATA_SUCCESS,
  POIDIRECTORIES_FETCH_DATA_FAIL,
  POIDIRECTORIES_UPLOAD_POI_INIT,
  POIDIRECTORIES_UPLOAD_POI_SUCCESS,
  POIDIRECTORIES_UPLOAD_POI_FAIL,
  POIDIRECTORIES_DELETE_POI_INIT,
  POIDIRECTORIES_DELETE_POI_SUCCESS,
  POIDIRECTORIES_DELETE_POI_FAIL,
  POIDIRECTORIES_CLEAR_DATA,
} from 'state/actions/poiDirectories';

const initialState = {
  list: [],
  total:0,
  loading: false,
  downloading: false,
  error: {
    errors: null,
    message: '',
  },
  success: false,
  deleted: false,
};

export const poiDirectoriesReducer = createReducer(
  {
    [POIDIRECTORIES_FETCH_DATA_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [POIDIRECTORIES_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      total: payload.total || payload.list.length,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [POIDIRECTORIES_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),

    [POIDIRECTORIES_DELETE_POI_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [POIDIRECTORIES_DELETE_POI_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      deleted: true,
    }),
    [POIDIRECTORIES_DELETE_POI_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [POIDIRECTORIES_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [POIDIRECTORIES_UPLOAD_POI_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [POIDIRECTORIES_UPLOAD_POI_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
    }),
    [POIDIRECTORIES_UPLOAD_POI_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),

  },
  initialState
);
